/**
 * NexWave theme loader.
 *
 * Desk pages read the mode from boot data. The login page reads it from the
 * guest API. Other website pages do not activate Desk theme styles.
 */
(function () {
	if (typeof window === "undefined" || window.NexWaveThemeLoader?.loaded)
		return;

	const STORAGE_KEY = "container_fullwidth";
	const THEME_ATTRIBUTE = "data-nexwave-theme";
	const MAX_FULL_WIDTH_RETRIES = 50;
	const MAX_BADGE_RETRIES = 20;

	let initialized = false;
	let badgeRetryCount = 0;

	window.NexWaveThemeLoader = {
		loaded: true,
	};

	function hasDeskBoot() {
		return Boolean(
			window.frappe &&
				window.frappe.boot &&
				window.frappe.boot.nexwave_theme_mode
		);
	}

	function isLoginPage() {
		return (
			window.location.pathname === "/login" ||
			document.body?.dataset?.path === "login"
		);
	}

	function setFullWidthPreference(enabled) {
		try {
			if (!window.localStorage) return;
			if (enabled) {
				window.localStorage.setItem(STORAGE_KEY, "true");
			} else {
				window.localStorage.removeItem(STORAGE_KEY);
			}
		} catch (error) {
			// The theme can still work when storage is blocked.
		}
	}

	function unbindFullWidthEvents() {
		if (window.$) {
			window.$(document).off(".nexwaveTheme");
		}
	}

	function enableFullWidth() {
		setFullWidthPreference(true);

		let attempts = 0;
		const ensureFullWidth = () => {
			const setter = window.frappe?.ui?.toolbar?.set_fullwidth_if_enabled;

			if (typeof setter === "function") {
				setter();
				return;
			}

			attempts += 1;
			if (attempts < MAX_FULL_WIDTH_RETRIES) {
				window.setTimeout(ensureFullWidth, 100);
			}
		};

		ensureFullWidth();

		if (window.$) {
			window
				.$(document)
				.off(".nexwaveTheme")
				.on(
					"app_ready.nexwaveTheme toggleFullWidth.nexwaveTheme",
					ensureFullWidth
				);
		}
	}

	function applyTheme(themeMode) {
		if (!themeMode || themeMode === "Disabled") {
			document.documentElement.removeAttribute(THEME_ATTRIBUTE);
			setFullWidthPreference(false);
			unbindFullWidthEvents();
			return;
		}

		if (themeMode === "Full") {
			document.documentElement.setAttribute(THEME_ATTRIBUTE, "full");
			enableFullWidth();
			return;
		}

		if (themeMode === "Modern Full (Preview)") {
			document.documentElement.setAttribute(THEME_ATTRIBUTE, "modern");
			enableFullWidth();
			return;
		}

		document.documentElement.setAttribute(THEME_ATTRIBUTE, "base");
		setFullWidthPreference(false);
		unbindFullWidthEvents();
	}

	function injectSiteBadge() {
		if (!hasDeskBoot()) return;

		const siteName = window.frappe.boot.nexwave_site_display_name;
		const isSandbox = window.frappe.boot.nexwave_is_sandbox;
		const themeMode = window.frappe.boot.nexwave_theme_mode;

		if (!siteName || themeMode === "Disabled") return;
		if (document.querySelector(".nexwave-site-badge")) return;

		const navbarBrand = document.querySelector(
			".navbar-brand, .navbar-home"
		);
		if (!navbarBrand) {
			if (badgeRetryCount < MAX_BADGE_RETRIES) {
				badgeRetryCount += 1;
				window.setTimeout(injectSiteBadge, 500);
			}
			return;
		}

		const badge = document.createElement("span");
		badge.className = `nexwave-site-badge ${
			isSandbox ? "sandbox" : "production"
		}`;
		badge.textContent = siteName;
		navbarBrand.parentNode.insertBefore(badge, navbarBrand.nextSibling);
		badgeRetryCount = 0;
	}

	function initializeDesk() {
		applyTheme(window.frappe.boot.nexwave_theme_mode);
		injectSiteBadge();
		window.addEventListener("load", injectSiteBadge, { once: true });
	}

	function initializeLogin() {
		window
			.fetch(
				"/api/method/erpnext_new_zealand_customizations.api.get_theme_mode"
			)
			.then((response) => response.json())
			.then((data) => applyTheme(data.message))
			.catch(() => applyTheme("Base (Colors Only)"));
	}

	function initialize() {
		if (initialized) return;
		initialized = true;

		if (hasDeskBoot()) {
			initializeDesk();
		} else if (isLoginPage()) {
			initializeLogin();
		}

		window.NexWaveThemeLoader.initialized = true;
		window.NexWaveThemeLoader.applyTheme = applyTheme;
	}

	if (hasDeskBoot() || document.readyState !== "loading") {
		initialize();
	} else {
		document.addEventListener("DOMContentLoaded", initialize, {
			once: true,
		});
	}
})();
